module.exports = __webpack_public_path__ + "static/media/verified.113e2c04.png";